import { cardImageSources, type GenericCharacter } from './types'

export const genericMomia: GenericCharacter = {
  id: 'generic-momia',
  enabled: true,
  order: 15,
  displayName: 'Ramsés',
  icon: '🏺',
  imageSources: cardImageSources('generic-momia'),
}
